<template>
  <div id="w_box">
    <Header :searchPage="searchPage" @goPage="goPage"></Header>
    <div class="content">
      <div class="con_w">
        <WhrSearch/>
        <div id="tab05" class="con act">
          <DateSearch @setDateSearh="setSearchChkDate"></DateSearch>
          <div class="tbl">
            <table>
              <colgroup>
                <col width="100">
                <col width="*">
                <col width="100">
                <col width="100">
                <col width="80">
                <col width="80">
                <col width="120">
                <col width="95">
                <col width="80">
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" rowspan="2" class="tp fst">종목코드</th>
                  <th scope="col" rowspan="2" class="tp">종목명</th>
                  <th scope="col" rowspan="2" class="tp">실적 기준</th>
                  <th scope="col" rowspan="2" class="tp">발표일</th>
                  <th scope="col" colspan="2" class="tp">EPS(USD)</th>
                  <th scope="col" rowspan="2" class="tp">
                    <select id="supVal" v-model="searchPage.supVal" @change="goSupPage()">
                      <option v-for="(option,index) in searchPage.supVals" v-bind:value="option.value" :key="index">{{option.text}}</option>
                    </select>
                  </th>
                  <th scope="col" rowspan="2" class="tp">컨센대비 <em>(%)</em></th>
                  <th scope="col" rowspan="2" class="tp lst">시가총액 <em>(mm)</em></th>
                </tr>
                <tr>
                  <th scope="col">발표</th>
                  <th scope="col">예측(Q)</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item,index) in searchPage.items">
                  <ErecordSub :item="item" :key="index"/>
                </template>
              </tbody>
            </table>
          </div>
          <Pagination :searchPage="searchPage" @goPage="goPage"/>
          <!-- //paging -->
          <div class="guide">
            * 어닝 판단 기준 : 희석주당순이익 컨센서스 대비 변화율 <br>
            * 출처 : EDGAR 실적공시(8-K, 10-Q, 10-K), GAAP기준 (Non-GAAP 확보시 우선 적용) <br>
            * 공시 규격 6-K의 ADR종목은 제공되지 않음
          </div>
          <!-- //guide -->

          <div class="time">
            한국시간 기준 {{ curTime }}
          </div>
          <!-- //time -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/kiwoom/usRecord/pc/common/Header'
import WhrSearch from '@/components/kiwoom/usRecord/pc/common/WhrSearch'
import DateSearch from '@/components/kiwoom/usRecord/pc/common/DateSearch'
import ErecordSub from '@/views/kiwoom/usRecord/pc/Erecord_sub'
import Pagination from '@/components/common/Pagination'
import {mapGetters} from 'vuex'
import axios from 'axios'
import { EventBus } from '@/store/event-bus'

export default {
  components: {
    Header,
    DateSearch,
    WhrSearch,
    ErecordSub,
    Pagination
  },
  data () {
    return {
      searchPage: {
        pageNo: 1,
        pageSize: 14,
        totalRows: 0,
        items: [],
        chkSDate: null,
        chkEDate: null,
        supVal: 'ALL',
        supVals: [
          {text: '전체', value: 'ALL'},
          {text: '어닝서프라이즈', value: 'supA'},
          {text: '예상수준상회', value: 'supB'},
          {text: '예상치부합', value: 'supC'},
          {text: '예상수준하회', value: 'supD'},
          {text: '어닝쇼크', value: 'supE'}
        ]
      },
      curTime: new Date().toLocaleString()
    }
  },
  methods: {
    getFormatDate (gb) {
      let date = new Date()
      let year = date.getFullYear()
      let month = (1 + date.getMonth())
      let day
      month = month >= 10 ? month : '0' + month
      if (gb === 'sdate') {
        day = '01'
      } else {
        day = date.getDate()
        day = day >= 10 ? day : '0' + day
      }
      return year + '' + month + '' + day
    },
    init () {
      const params = {
        chkIndex: this.getUsRecordSettings.chkIndex,
        pageNo: this.searchPage.pageNo,
        pageSize: this.searchPage.pageSize,
        symbol: this.getUsRecordSettings.symbol,
        chkDate: this.getUsRecordSettings.chkDate,
        chkSDate: this.searchPage.chkSDate,
        chkEDate: this.searchPage.chkEDate,
        supVal: this.searchPage.supVal
      }

      this.$store.dispatch('setLodingBarSetting', true)

      let postUrl = 'https://security.thinkpool.com/api/us/kw/calendar/getUsStockDataListAjax.do'
      axios.post(postUrl, params).then((res) => {
        if (res.data.resCode === '1') {
          this.searchPage.totalRows = res.data.resObj.totalRows
          this.searchPage.items = res.data.resObj.egsList
          this.curTime = new Date().toLocaleString()
        }
        this.$store.dispatch('setLodingBarSetting', false)
      })
    },
    goPage (pageNo) {
      this.searchPage.pageNo = parseInt(pageNo)
      this.init()
    },
    goSupPage () {
      this.searchPage.supVal = $('#supVal').val()
      this.goPage('1')
    },
    openMemo () {
      $('.p_inv').toggle()
    },
    closeMemo () {
      $('.p_inv').hide()
    },
    setSymbolDataReset () {
      localStorage.setItem('symbol', '')
      localStorage.setItem('syName', '')
      this.$store.dispatch('saveUsSymbolSetting', '')
      this.$store.dispatch('saveUsSyNameSetting', '')
    },
    setSearchChkDate (searchPage) {
      this.searchPage.chkSDate = searchPage.chkSDate
      this.searchPage.chkEDate = searchPage.chkEDate
      this.goPage('1')
    }
  },
  computed: {
    ...mapGetters(['getUsRecordSettings']),
    getChkIndex () {
      return this.getUsRecordSettings.chkIndex
    },
    getSymbol () {
      return this.getUsRecordSettings.symbol
    },
    getSyName () {
      return this.getUsRecordSettings.syName
    },
    getPageNo () {
      return this.searchPage.pageNo
    },
    getChkDate () {
      return this.getUsRecordSettings.chkDate
    }
  },
  created () {
    if (this.getUsRecordSettings.chkIndex !== 'SYMBOL') {
      this.setSymbolDataReset()
    }
    this.searchPage.chkSDate = 'D'
    this.$store.dispatch('saveUsChkDateSetting', 'D')

    this.searchPage.chkSDate = this.getFormatDate('sdate')
    this.searchPage.chkEDate = this.getFormatDate('edate')
    this.goPage('1')
    EventBus.$on('pageNo', (val) => {
      this.searchPage.pageNo = val
    })
  },
  watch: {
    getChkIndex (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('chkIndex', val)
        if (val !== 'SYMBOL') {
          this.setSymbolDataReset()
        }
        this.goPage('1')
      }
    },
    getSymbol (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('symbol', val)
        this.goPage('1')
      }
    },
    getSyName (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('syName', val)
      }
    },
    getPageNo (val, oldVal) {
      if (val !== oldVal) {
        EventBus.$emit('pageNo', val)
      }
    },
    getChkDate (val, oldVal) {
      if (val !== oldVal) {
        this.goPage('1')
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/pc/Erecord.vue